import { render, staticRenderFns } from "./ImitationInput.vue?vue&type=template&id=33532c3c&scoped=true&"
import script from "./ImitationInput.vue?vue&type=script&lang=js&"
export * from "./ImitationInput.vue?vue&type=script&lang=js&"
import style0 from "./ImitationInput.vue?vue&type=style&index=0&id=33532c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33532c3c",
  null
  
)

export default component.exports